import React, { useState } from "react";
import quantumLogo from "../../quantum-care-logo.png";
import "../../App.css";
import Header from "./PublicHeader";
import Footer from "./PublicFooter";
import Login from "../Login/Login";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { GetAppointmentsApi } from "../Patient/PatientAPI";

function LandingNurse() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const dispatch = useDispatch();

  return (
    <div classNameName="App">
      <Header />

      <main id="main-content">
        {/* section 1 */}
        <section
          id="home"
          aria-labelledby="hero-title"
          className="bg-blue-50 py-8"
        >
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12">
              {/* Left Content */}
              <div className="flex-1 space-y-6">
                <h1
                  id="hero-title"
                  className="text-4xl sm:text-5xl font-bold leading-tight text-gray-900"
                >
                  <span className="text-blue-600">Tele-Med</span> for Maldives
                </h1>
                <p className="text-lg text-gray-600 max-w-lg">
                  A single SaaS platform that uses Smart PreDiagnosis to triage
                  symptoms, book appointments, power video consults, and keep
                  every record secure.
                </p>

                {/* CTA Buttons */}
                <div className="flex gap-4">
                  <button
                    onClick={() => setIsLoginOpen(true)}
                    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-5 py-2 rounded-lg"
                  >
                    Login / Register
                  </button>
                  {/* <button className="px-6 py-3 rounded-lg border border-blue-600 text-blue-600 font-medium hover:bg-blue-50">
                    Try Interactive Demo
                  </button> */}
                </div>

                {/* Trust Badges */}
                <div className="flex flex-wrap gap-4">
                  {[
                    "HIPAA-grade security",
                    "ISO-ready",
                    "Low-bandwidth video",
                    "Data residency options",
                  ].map((text, i) => (
                    <div
                      key={i}
                      className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg shadow-sm"
                    >
                      <span className="text-green-500">✓</span>
                      <span className="text-gray-700">{text}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Card */}
              <div className="flex-1 max-w-md">
                <div className="bg-white rounded-2xl shadow-lg p-6 space-y-4">
                  <div className="flex items-center gap-4 border-b pb-4">
                    <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center text-white font-semibold">
                      AH
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">Ahmed Hassan</h4>
                      <p className="text-sm text-gray-500">
                        Patient ID: #12345
                      </p>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="bg-gray-100 p-3 rounded-lg">
                      I've been having chest pain and shortness of breath
                    </div>
                    <div className="bg-blue-50 p-3 rounded-lg">
                      Based on your symptoms, I recommend urgent consultation.
                      I'm booking you with Dr. Sarah immediately.
                    </div>
                    <div className="bg-blue-50 p-3 rounded-lg">
                      Your appointment is confirmed for 2:30 PM today.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* section 2 */}
        <section
          id="how-it-works"
          aria-labelledby="how-it-works-title"
          className="py-12 bg-white"
        >
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            {/* Title */}
            <h2
              id="how-it-works-title"
              className="text-center text-3xl sm:text-4xl font-bold mb-12"
            >
              How it Works
            </h2>

            {/* Steps */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Step 1 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-bold">
                  1
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Patient Registration
                </h3>
                <p className="text-gray-600">
                  Patients register using their national ID or health card,
                  creating a secure digital health profile with multi-language
                  support.
                </p>
              </div>

              {/* Step 2 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-bold">
                  2
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Smart PreDiagnosis
                </h3>
                <p className="text-gray-600">
                  Our Smart PreDiagnosis performs smart triage, asking relevant
                  questions to understand symptoms and recommend appropriate
                  care pathways.
                </p>
              </div>

              {/* Step 3 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-blue-600 text-white text-lg font-bold">
                  3
                </div>
                <h3 className="text-xl font-semibold mb-2">
                  Doctor Consultation
                </h3>
                <p className="text-gray-600">
                  Connect with qualified doctors through secure video
                  consultations, enhanced by Smart PreDiagnosis insights that
                  support clinical decision-making.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* section 3 */}
        <section
          id="features"
          aria-labelledby="patient-features-title"
          className="py-12 bg-gray-50"
        >
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            {/* Section Title */}
            <h2
              id="patient-features-title"
              className="text-center text-3xl sm:text-4xl font-bold mb-12"
            >
              Features for Patients
            </h2>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Feature 1 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">👤</div>
                <h3 className="text-xl font-semibold mb-2">
                  Registration & Login
                </h3>
                <p className="text-gray-600">
                  Seamless registration with national ID integration and secure
                  biometric authentication options.
                </p>
              </div>

              {/* Feature 2 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🏠</div>
                <h3 className="text-xl font-semibold mb-2">
                  Personal Dashboard
                </h3>
                <p className="text-gray-600">
                  Comprehensive health overview with appointment history,
                  medications, and health metrics tracking.
                </p>
              </div>

              {/* Feature 3 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🧠</div>
                <h3 className="text-xl font-semibold mb-2">
                  Smart PreDiagnosis
                </h3>
                <p className="text-gray-600">
                  Intelligent symptom checker that guides patients to
                  appropriate care levels and specialists.
                </p>
              </div>

              {/* Feature 4 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🗓️</div>
                <h3 className="text-xl font-semibold mb-2">
                  Appointment Booking
                </h3>
                <p className="text-gray-600">
                  Easy scheduling with real-time availability, automated
                  reminders, and calendar integration.
                </p>
              </div>

              {/* Feature 5 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">📝</div>
                <h3 className="text-xl font-semibold mb-2">
                  Appointments List
                </h3>
                <p className="text-gray-600">
                  Complete appointment history with status tracking, notes, and
                  follow-up scheduling.
                </p>
              </div>

              {/* Feature 6 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">📄</div>
                <h3 className="text-xl font-semibold mb-2">
                  Appointment Details
                </h3>
                <p className="text-gray-600">
                  Detailed consultation summaries, prescriptions, and
                  recommended follow-up actions.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* section 4 */}
        <section
          aria-labelledby="doctor-features-title"
          className="py-12 bg-white"
        >
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            {/* Section Title */}
            <h2
              id="doctor-features-title"
              className="text-center text-3xl sm:text-4xl font-bold mb-12"
            >
              Features for Doctors
            </h2>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {/* Feature 1 */}
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🏥</div>
                <h3 className="text-xl font-semibold mb-2">Doctor Dashboard</h3>
                <p className="text-gray-600">
                  Comprehensive patient management system with schedule
                  optimization, patient queues, and performance analytics.
                </p>
              </div>

              {/* Feature 2 */}
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🧠</div>
                <h3 className="text-xl font-semibold mb-2">
                  Smart PreDiagnosis Panel
                </h3>
                <p className="text-gray-600">
                  Clinical decision support with differential diagnosis
                  suggestions, drug interactions, and evidence-based
                  recommendations.
                </p>
              </div>

              {/* Feature 3 */}
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">📹</div>
                <h3 className="text-xl font-semibold mb-2">
                  Video Consultation
                </h3>
                <p className="text-gray-600">
                  High-quality, low-bandwidth video calls with screen sharing,
                  digital stethoscope integration, and recording capabilities.
                </p>
              </div>

              {/* Feature 4 */}
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">📝</div>
                <h3 className="text-xl font-semibold mb-2">
                  Post-Consult Actions
                </h3>
                <p className="text-gray-600">
                  Streamlined e-prescriptions, referral management, follow-up
                  scheduling, and automated billing integration.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* section 5 */}
        <section
          aria-labelledby="smart-trust-title"
          className="py-12 bg-gray-50"
        >
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            {/* Section Title */}
            <h2
              id="smart-trust-title"
              className="text-center text-3xl sm:text-4xl font-bold mb-12"
            >
              Trusted Smart PreDiagnosis
            </h2>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              {/* Feature 1 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">👨‍⚕️</div>
                <h3 className="text-xl font-semibold mb-2">
                  Clinician-in-the-loop
                </h3>
                <p className="text-gray-600">
                  Smart PreDiagnosis recommendations always require physician
                  review and approval, ensuring human oversight in all clinical
                  decisions.
                </p>
              </div>

              {/* Feature 2 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🛡️</div>
                <h3 className="text-xl font-semibold mb-2">
                  Safety & Bias Prevention
                </h3>
                <p className="text-gray-600">
                  Continuous monitoring for bias, regular updates, and extensive
                  testing across diverse populations.
                </p>
              </div>

              {/* Feature 3 */}
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">📋</div>
                <h3 className="text-xl font-semibold mb-2">
                  Full Auditability
                </h3>
                <p className="text-gray-600">
                  Complete decision trails, explainable Smart PreDiagnosis
                  outputs, and comprehensive logging for regulatory compliance.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* section 6 */}
        <section aria-labelledby="security-title" className="py-12 bg-white">
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            {/* Section Title */}
            <h2
              id="security-title"
              className="text-center text-3xl sm:text-4xl font-bold mb-12"
            >
              Security & HIPAA Compliance
            </h2>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              {/* Feature 1 */}
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🔒</div>
                <h3 className="text-xl font-semibold mb-2">
                  End-to-End Encryption
                </h3>
                <p className="text-gray-600">
                  Military-grade AES-256 encryption for all data in transit and
                  at rest, with regular security audits and penetration testing
                  — fully aligned with HIPAA standards.
                </p>
              </div>

              {/* Feature 2 */}
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🔑</div>
                <h3 className="text-xl font-semibold mb-2">
                  Advanced Access Control
                </h3>
                <p className="text-gray-600">
                  Role-based permissions, multi-factor authentication, and
                  zero-trust security architecture ensure HIPAA-compliant
                  protection of sensitive healthcare data.
                </p>
              </div>

              {/* Feature 3 */}
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🌍</div>
                <h3 className="text-xl font-semibold mb-2">
                  Data Residency & Compliance
                </h3>
                <p className="text-gray-600">
                  Flexible data hosting options with guaranteed data
                  sovereignty, meeting HIPAA and local healthcare regulations
                  for complete compliance.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* section 7 */}
        {/* <section aria-labelledby="maldives-title" className="py-12 bg-gray-50">
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            <h2
              id="maldives-title"
              className="text-center text-3xl sm:text-4xl font-bold mb-12"
            >
              Built Specifically for Maldives
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🌐</div>
                <h3 className="text-xl font-semibold mb-2">
                  Dhivehi/English Toggle
                </h3>
                <p className="text-gray-600">
                  Full bilingual support with cultural adaptations and local
                  healthcare terminology integration.
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">📶</div>
                <h3 className="text-xl font-semibold mb-2">
                  Low-Bandwidth Modes
                </h3>
                <p className="text-gray-600">
                  Optimized for island connectivity with offline capabilities
                  and data compression for remote areas.
                </p>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🏛️</div>
                <h3 className="text-xl font-semibold mb-2">
                  Government Dashboard
                </h3>
                <p className="text-gray-600">
                  Real-time public health monitoring, epidemic tracking, and
                  resource allocation insights for health authorities.
                </p>
              </div>
            </div>
          </div>
        </section> */}

        {/* section 8 */}
        {/* <section
          aria-labelledby="integrations-title"
          className="py-12 bg-white"
        >
          <div className="max-w-7xl w-full mx-auto py-12 px-4">
            <h2
              id="integrations-title"
              className="text-center text-3xl sm:text-4xl font-bold mb-12"
            >
              Seamless Integrations
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">💬</div>
                <h3 className="text-xl font-semibold mb-2">
                  Video & Messaging
                </h3>
                <p className="text-gray-600">
                  Integration with popular messaging platforms and video
                  conferencing solutions for flexible communication.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🏥</div>
                <h3 className="text-xl font-semibold mb-2">Labs & Pharmacy</h3>
                <p className="text-gray-600">
                  Direct integration with diagnostic labs and pharmacies for
                  streamlined test ordering and prescription fulfillment.
                </p>
              </div>

              <div className="bg-gray-50 rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
                <div className="text-3xl mb-4">🔌</div>
                <h3 className="text-xl font-semibold mb-2">Open APIs</h3>
                <p className="text-gray-600">
                  Comprehensive API suite for integration with existing hospital
                  systems and third-party healthcare applications.
                </p>
              </div>
            </div>
          </div>
        </section> */}

        {/* section 9 */}
        <section className="py-12 bg-white" aria-labelledby="outcomes-title">
          <div className="max-w-6xl mx-auto px-4">
            <h2
              id="outcomes-title"
              className="text-3xl font-bold text-center mb-12"
            >
              Proven Outcomes
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-gray-100 rounded-lg p-6 text-center shadow hover:shadow-lg transition">
                <div className="text-4xl font-extrabold text-blue-600">85%</div>
                <div className="mt-2 text-gray-700">
                  Reduction in waiting times
                </div>
              </div>
              <div className="bg-gray-100 rounded-lg p-6 text-center shadow hover:shadow-lg transition">
                <div className="text-4xl font-extrabold text-green-600">
                  92%
                </div>
                <div className="mt-2 text-gray-700">
                  Patient satisfaction rate
                </div>
              </div>
              <div className="bg-gray-100 rounded-lg p-6 text-center shadow hover:shadow-lg transition">
                <div className="text-4xl font-extrabold text-purple-600">
                  78%
                </div>
                <div className="mt-2 text-gray-700">
                  Faster diagnosis accuracy
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* section 10 */}
        {/* <section
          className="section"
          id="contact"
          aria-labelledby="contact-title"
        >
          <div className="container">
            <h2
              id="contact-title"
              //style="text-align: center; margin-bottom: 3rem"
            >
              Get Started Today
            </h2>
            <div className="form">
              <form id="contact-form" novalidate>
                <div className="grid grid-2">
                  <div className="form-group">
                    <label for="name" className="form-label">
                      Full Name *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-input"
                      required
                      aria-describedby="name-error"
                    />
                    <div
                      id="name-error"
                      className="error-message"
                      role="alert"
                    ></div>
                  </div>
                  <div className="form-group">
                    <label for="organization" className="form-label">
                      Organization *
                    </label>
                    <input
                      type="text"
                      id="organization"
                      name="organization"
                      className="form-input"
                      required
                      aria-describedby="org-error"
                    />
                    <div
                      id="org-error"
                      className="error-message"
                      role="alert"
                    ></div>
                  </div>
                </div>

                <div className="grid grid-2">
                  <div className="form-group">
                    <label for="email" className="form-label">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-input"
                      required
                      aria-describedby="email-error"
                    />
                    <div
                      id="email-error"
                      className="error-message"
                      role="alert"
                    ></div>
                  </div>
                  <div className="form-group">
                    <label for="phone" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-input"
                      aria-describedby="phone-error"
                    />
                    <div
                      id="phone-error"
                      className="error-message"
                      role="alert"
                    ></div>
                  </div>
                </div>

                <div className="grid grid-2">
                  <div className="form-group">
                    <label for="role" className="form-label">
                      Your Role *
                    </label>
                    <select
                      id="role"
                      name="role"
                      className="form-select"
                      required
                      aria-describedby="role-error"
                    >
                      <option value="">Select your role</option>
                      <option value="healthcare-admin">
                        Healthcare Administrator
                      </option>
                      <option value="doctor">Doctor/Clinician</option>
                      <option value="it-manager">IT Manager</option>
                      <option value="government">Government Official</option>
                      <option value="other">Other</option>
                    </select>
                    <div
                      id="role-error"
                      className="error-message"
                      role="alert"
                    ></div>
                  </div>
                  <div className="form-group">
                    <label for="use-case" className="form-label">
                      Primary Use Case *
                    </label>
                    <select
                      id="use-case"
                      name="use-case"
                      className="form-select"
                      required
                      aria-describedby="usecase-error"
                    >
                      <option value="">Select use case</option>
                      <option value="telemedicine">
                        Telemedicine Implementation
                      </option>
                      <option value="ai-triage">AI-Powered Triage</option>
                      <option value="ehr-integration">EHR Integration</option>
                      <option value="population-health">
                        Population Health Management
                      </option>
                      <option value="other">Other</option>
                    </select>
                    <div
                      id="usecase-error"
                      className="error-message"
                      role="alert"
                    ></div>
                  </div>
                </div>

                <div className="form-group">
                  <label for="notes" className="form-label">
                    Additional Notes
                  </label>
                  <textarea
                    id="notes"
                    name="notes"
                    className="form-textarea"
                    placeholder="Tell us about your specific requirements or questions..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  // style="width: 100%"
                >
                  Submit Demo Request
                </button>
              </form>
            </div>
          </div>
        </section> */}
        <div className="bg-red-50 border-l-4 border-red-400 p-4">
          <div className="flex items-center max-w-7xl mx-auto px-4">
            <div className="flex">
              <div className="flex-shrink-0">
                <span className="text-red-400 text-xl">⚠️</span>
              </div>
              <div className="ml-3">
                <p className="text-lg text-red-700">
                  <strong>Emergency Notice:</strong> For medical emergencies,
                  please contact{" "}
                  <a
                    href="tel:911"
                    className="font-bold text-red-800 hover:underline"
                  >
                    911
                  </a>{" "}
                  immediately. This platform is for non-emergency consultations
                  only.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <Login
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        loginFor="nurse"
      />
    </div>
  );
}

export default LandingNurse;
